import { useContext } from "react";
import { MainContext, PlayMode } from "../App";
import { Switch } from "antd";
import { PauseOutlined } from "@ant-design/icons";
import { ActionState, ActionType, applyOnMatch } from "../controllers/world";

const ActionSwitchOptions = () => {
  const { appState: context, setAppState: setContext } =
    useContext(MainContext);

  const switchAction = (actionType: ActionType) => (checked: boolean) => {
    setContext({
      ...context,
      world: {
        ...context.world,
        actionsPerTurn: applyOnMatch<ActionState>(
          context.world.actionsPerTurn,
          (a) => a.type === actionType,
          (a) => ({ ...a, isActive: checked })
        ),
      },
    });
  };

  return (
    <div>
      {context.world.actionsPerTurn.map((a) => (
        <div key={`switch-wrapper-${a.type}`}>
          <Switch defaultChecked onChange={switchAction(a.type)} size="small" />{" "}
          {a.type}
        </div>
      ))}
    </div>
  );
};

export default ActionSwitchOptions;
